import React from "react";
import styled from "styled-components";

const TextContainer = styled.div`
        text-align: left;
        margin:3% auto;
`;

export default function ArticleCard(props) {
    const cardData = props.data;
    const renderCard = (card, index) => {
        return (
            <div style={{
                alignItems: 'center',
                }} key={index}>
                <TextContainer>
                    <h1>{card.title}</h1>
                    <p>{card.description}</p>
                </TextContainer>
            </div>
        );
    }

    return (
        cardData.map(renderCard)
    );
}
